import { Image } from 'foundations-components/transitional/components/Image';

// @ts-ignore svg import
import SmartCrmSvg from 'bender-url!./images/SmartCrm.svg';
import { MERCH_CARD_PRODUCT_ICON_STYLE_PROPS, PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS } from './styleProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SmartCrmProductIcon = ({
  useCase = 'productPageTitle'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: SmartCrmSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};